import React from "react";
import { Link } from "react-router-dom";
import PublicNavigation from "../components/PublicNavigation";
import PublicFooter from "../components/PublicFooter";
import { usePageMeta } from "../hooks/usePageMeta";
import "./LegalPage.css";

const TermsPage: React.FC = () => {
  React.useEffect(() => {
    document.body.classList.add("homepage-route");
    return () => {
      document.body.classList.remove("homepage-route");
    };
  }, []);

  usePageMeta({
    title: "Termini e Condizioni – CosaVorrei",
    description: "Termini e condizioni d'uso del servizio CosaVorrei.",
    canonicalUrl: "https://www.cosavorrei.it/termini",
    ogUrl: "https://www.cosavorrei.it/termini",
    ogImage: "https://www.cosavorrei.it/og-image.png",
  });

  return (
    <div className="legal-page">
      <PublicNavigation />
      
      <main className="legal-content">
        <div className="legal-container">
          <h1>Termini e Condizioni</h1>
          <p className="legal-updated">Ultimo aggiornamento: 8 novembre 2025</p>

          <section className="legal-section">
            <h2>1) Oggetto del servizio</h2>
            <p>
              CosaVorrei consente di creare gruppi privati, eventi e liste di desideri, con prenotazioni regalo visibili ai soli membri secondo le impostazioni dell'evento.
            </p>
            <p>
              Il servizio è attualmente gratuito. Possiamo introdurre funzioni a pagamento in futuro con termini economici separati.
            </p>
          </section>

          <section className="legal-section">
            <h2>2) Registrazione e account</h2>
            <ul>
              <li>Devi fornire dati veritieri e custodire le credenziali.</li>
              <li>Sei responsabile delle attività svolte con il tuo account.</li>
              <li>Possiamo sospendere o chiudere account che violano questi Termini o creano rischi per altri utenti o per il servizio.</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>3) Uso consentito</h2>
            <p>È vietato usare CosaVorrei per:</p>
            <ul>
              <li>attività illegali, spam, scraping, tentativi di intrusione, distribuzione di malware;</li>
              <li>pubblicare contenuti illeciti, diffamatori, osceni, discriminatori o che violano diritti altrui;</li>
              <li>creare gruppi o eventi pubblici di massa. CosaVorrei è pensato per cerchie private.</li>
            </ul>
            <p>Possiamo rimuovere contenuti o limitare l'accesso in caso di abuso.</p>
          </section>

          <section className="legal-section">
            <h2>4) Contenuti dell'utente</h2>
            <p>
              Rimani titolare dei contenuti che carichi. Concedi a CosaVorrei una licenza d'uso limitata, non esclusiva e revocabile per ospitare e mostrare i contenuti 
              al solo scopo di erogare il servizio e secondo le impostazioni di privacy del gruppo/evento.
            </p>
          </section>

          <section className="legal-section">
            <h2>5) Proprietà intellettuale</h2>
            <p>
              Il software, il design e il marchio CosaVorrei appartengono al Titolare. Non puoi copiarli, decompilarli o riutilizzarli senza consenso scritto.
            </p>
          </section>

          <section className="legal-section">
            <h2>6) Comunicazioni</h2>
            <p>
              Inviamo email o notifiche operative su inviti, eventi e prenotazioni. Niente newsletter promozionali senza tuo consenso.
            </p>
          </section>

          <section className="legal-section">
            <h2>7) Disponibilità e manutenzione</h2>
            <p>
              Facciamo il possibile per mantenere il servizio disponibile. Potrebbero esserci interruzioni per manutenzione, aggiornamenti o cause di forza maggiore.
            </p>
          </section>

          <section className="legal-section">
            <h2>8) Limitazione di responsabilità</h2>
            <p>
              CosaVorrei è offerto "così com'è". Nei limiti consentiti dalla legge non rispondiamo di danni indiretti, perdita di dati o profitti. 
              Restiamo comunque responsabili nei casi in cui la legge lo impone.
            </p>
          </section>

          <section className="legal-section">
            <h2>9) Chiusura account</h2>
            <p>
              Puoi cancellare l'account in qualsiasi momento dalle impostazioni o scrivendo a <a href="mailto:info@cosavorrei.it">info@cosavorrei.it</a>. 
              Possiamo chiudere o sospendere l'account in caso di violazioni gravi o ripetute.
            </p>
          </section>

          <section className="legal-section">
            <h2>10) Privacy e cookie</h2>
            <p>
              L'uso del servizio è disciplinato anche dalla <Link to="/privacy">Privacy Policy</Link>, 
              che fa parte integrante di questi Termini.
            </p>
          </section>

          <section className="legal-section">
            <h2>11) Legge applicabile e foro</h2>
            <p>
              Questi Termini sono regolati dalla legge italiana. Per ogni controversia è competente, in via esclusiva, il Foro di Trento, 
              salvo i diritti inderogabili del consumatore.
            </p>
          </section>

          <section className="legal-section">
            <h2>12) Modifiche ai Termini</h2>
            <p>
              Possiamo aggiornare i Termini. Le modifiche saranno pubblicate sul sito e, se rilevanti, comunicate via email o in-app. 
              L'uso del servizio dopo la pubblicazione implica accettazione.
            </p>
            <p>
              <strong>Contatti legali:</strong> <a href="mailto:info@cosavorrei.it">info@cosavorrei.it</a>
            </p>
          </section>
        </div>
      </main>

      <PublicFooter />
    </div>
  );
};

export default TermsPage;
